/**
 * BMM — Reviews Section
 * File: bmm-reviews.js
 * Version: 1.0
 * Modules:
 *  1. Slider — DOM-based calc, arrows, dots, drag, keyboard, resize
 *  2. Rating bar animation — IntersectionObserver fills bars on scroll
 *  3. Theme editor re-init
 */
(function () {
  'use strict';

  function init(section) {
    var sid      = section.dataset.sectionId;
    var clip     = document.getElementById('bmm-rv-clip-' + sid);
    var track    = document.getElementById('bmm-rv-track-' + sid);
    var dotsWrap = document.getElementById('bmm-rv-dots-' + sid);
    var arrowsEl = document.getElementById('bmm-rv-arrows-' + sid);
    var btnP     = document.getElementById('bmm-rv-prev-' + sid);
    var btnN     = document.getElementById('bmm-rv-next-' + sid);

    /* ── 1. SLIDER ── */
    if (clip && track) {
      var cards   = Array.from(track.querySelectorAll('.bmm-rv__card'));
      var N       = cards.length;
      var cur     = 0;
      var VISIBLE = 3;
      var GAP     = 4;
      var cardW   = 0;
      var MAX     = 0;

      function isMobile() { return window.innerWidth <= 768; }

      function calculate() {
        if (isMobile()) return;
        VISIBLE = window.innerWidth <= 1100 ? 2 : 3;
        var style  = window.getComputedStyle(clip);
        var padL   = parseFloat(style.paddingLeft)  || 0;
        var padR   = parseFloat(style.paddingRight) || 0;
        var W      = clip.offsetWidth - padL - padR;
        cardW = Math.floor((W - GAP * (VISIBLE - 1)) / VISIBLE);
        MAX   = Math.max(0, N - VISIBLE);
        cards.forEach(function (c) { c.style.flexBasis = cardW + 'px'; });
      }

      function render() {
        if (isMobile()) return;
        track.style.transform = 'translateX(-' + (cur * (cardW + GAP)) + 'px)';
        var dots = dotsWrap ? dotsWrap.querySelectorAll('.bmm-rv__dot') : [];
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === cur);
          d.setAttribute('aria-pressed', i === cur ? 'true' : 'false');
        });
        if (btnP) btnP.setAttribute('aria-disabled', cur <= 0 ? 'true' : 'false');
        if (btnN) btnN.setAttribute('aria-disabled', cur >= MAX ? 'true' : 'false');
      }

      function updateControls() {
        if (isMobile()) {
          if (arrowsEl) arrowsEl.style.display = 'none';
          if (dotsWrap) dotsWrap.style.display  = 'none';
          track.style.transform = '';
          cards.forEach(function (c) { c.style.flexBasis = ''; });
          return;
        }
        var show = MAX > 0;
        if (arrowsEl) arrowsEl.style.display = show ? '' : 'none';
        if (dotsWrap) dotsWrap.style.display  = show ? '' : 'none';
      }

      function buildDots() {
        if (!dotsWrap) return;
        dotsWrap.innerHTML = '';
        if (MAX <= 0) return;
        for (var i = 0; i <= MAX; i++) {
          var btn = document.createElement('button');
          btn.className = 'bmm-rv__dot' + (i === 0 ? ' is-active' : '');
          btn.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          btn.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');
          btn.dataset.idx = i;
          btn.addEventListener('click', function () { go(parseInt(this.dataset.idx, 10)); });
          dotsWrap.appendChild(btn);
        }
      }

      function go(n) {
        cur = Math.max(0, Math.min(n, MAX));
        render();
      }

      if (btnN) btnN.addEventListener('click', function () {
        if (btnN.getAttribute('aria-disabled') !== 'true') go(cur + 1);
      });
      if (btnP) btnP.addEventListener('click', function () {
        if (btnP.getAttribute('aria-disabled') !== 'true') go(cur - 1);
      });

      /* Drag */
      var dx0 = 0, dragging = false, dragged = false;
      track.addEventListener('pointerdown', function (e) {
        if (isMobile()) return;
        dx0 = e.clientX; dragging = true; dragged = false;
        if (track.setPointerCapture) track.setPointerCapture(e.pointerId);
      });
      track.addEventListener('pointermove', function (e) {
        if (!dragging || isMobile()) return;
        var dx = e.clientX - dx0;
        if (Math.abs(dx) > 44) { dragging = false; dragged = true; dx < 0 ? go(cur + 1) : go(cur - 1); }
      });
      track.addEventListener('pointerup', function (e) {
        if (dragged) e.preventDefault();
        dragging = false; dragged = false;
      });

      /* Keyboard — always remove+re-add so re-init captures fresh go() closure */
      if (section._bmmRvKeyHandler) {
        section.removeEventListener('keydown', section._bmmRvKeyHandler);
      }
      section._bmmRvKeyHandler = function (e) {
        if (isMobile()) return;
        if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
        if (e.key === 'ArrowLeft')  { e.preventDefault(); go(cur - 1); }
      };
      section.setAttribute('tabindex', '0');
      section.addEventListener('keydown', section._bmmRvKeyHandler);

      /* Resize */
      var resizeTimer = null;
      function onResize() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          calculate(); updateControls(); buildDots();
          cur = Math.min(cur, MAX);
          render();
        }, 200);
      }
      if (section._bmmRvResize) window.removeEventListener('resize', section._bmmRvResize);
      section._bmmRvResize = onResize;
      window.addEventListener('resize', onResize, { passive: true });

      calculate();
      buildDots();
      updateControls();
      render();
    }

  }

  function initAll() {
    document.querySelectorAll('.bmm-rv[data-section-id]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('.bmm-rv[data-section-id]');
    if (s) init(s);
  });

})();
